export const getRelativeIndicies = (state: boolean[], index: number): [start: number, end: number] | null => {
  // check unrelated
  let current: boolean = state[index]
  let previous: boolean | undefined = state[index - 1]

  if (state.length < 2 || (current === false && (previous === undefined || previous === false))) {
    return null
  }

  // start index is the first true, including self
  let reverseIndex = state.slice(0, index).reverse().indexOf(false)

  let startIndex = index - reverseIndex

  // end index is the first false, including self
  let endIndex = state.indexOf(false, index)

  if (endIndex < 0) {
    endIndex = state.length - 1
  }

  return [startIndex, endIndex]
}
